import React, { useState } from "react";
import { Modal, Tooltip, Badge } from "antd";
import { BulbOutlined } from "@ant-design/icons";


// Component for handling modal functionality
const PropertyWithModal = ({ property, details }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const notices = details?.recommendation != null;

    console.log(details?.recommendation)

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <span style={{ fontWeight: "bold" }}>
                {property}
                {notices &&
                    <Tooltip>
                        <BulbOutlined 
                            style={{ color: "#dbbb1a", paddingLeft: 6, fontSize: 16, cursor: "pointer" }} 
                            onClick={showModal} 
                        />
                    </Tooltip>
                }
            </span>

            {notices &&
                <Modal 
                    //title={<span style={{ fontSize: '20px' }}>{`Recommendation for ${property}`}</span>}
                    open={isModalVisible} 
                    onOk={handleOk} 
                    onCancel={handleCancel}
                    footer={null}
                    closeIcon={null}
                    className="recommendationModal"
                    styles={{
                        header: {color: '#333'},
                        body: { color: '#555', fontSize: '18px', paddingLeft: 0 }
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'flex-start', padding: '2px', background: '#f5f5f5' }}>
                        <button onClick={handleCancel} style={{ border: 'none', background: '#f5f5f5', fontSize: '20px', cursor: 'pointer' }}>×</button>
                    </div>
                    <Badge.Ribbon text={details.recommendation.ribbon} style={{ fontSize: '16px', height: '32px', lineHeight: '32px', padding: '0 22px' }}>
                        <div style={{ padding: 16, background: '#f5f5f5' }}>
                            {details.recommendation.content}
                        </div>
                    </Badge.Ribbon>
                </Modal>
            }
        </>
    );
};

export default PropertyWithModal;